<!-- =========================================================================================
  File Name: AddNewDataSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>SITE LINK</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>
    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">
          {{DataJSON}}
        <span v-if="LinkData">
           <span v-if="LinkData.components">
             <span v-for="(comp,index) in LinkData.components" :key="index">
                 <span v-if="comp.type==='textnode'">
                       <vs-input label="Text" v-model="comp.content" class="mb-base w-full"></vs-input>
                 </span>
             </span>
           </span>
          <vs-input label="Link" v-model="LinkData.attributes.href" class="mb-base w-full"></vs-input>
        </span>
          <!-- <span v-for="(location,lindex) in headerData.locations" :key="lindex">
               <div>
                 <label for="" class="font-bold">Location: {{lindex+1}}</label>
                 <vs-input label="Name" v-model="location.name" class="w-full mb-base mt-2"></vs-input>
                 <vs-input label="Map" v-model="location.map" class="w-full mb-base"></vs-input>
                 <vs-input label="Phone" v-model="location.phone" class="w-full mb-base"></vs-input>
                 <vs-input label="Phone Link" v-model="location.phone_link" class="w-full mb-base"></vs-input>
                 <vs-input label="Email" v-model="location.email" class="w-full mb-base"></vs-input>
                 <vs-input label="Email Link" v-model="location.email_link" class="w-full"></vs-input>
               </div>
               <br>

          </span> -->
      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Save</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {} from "@/graphql";

export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: String,
    }
  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      },
      LinkData:null,
      headerData:{
          "locations":[
              {
                "name":"Boise",
                "map":"https://goo.gl/maps/R3MuQFjDkSYu76PY9",
                "phone":"(208) 391-2222",
                "phone_link":"+12083912222",
                "email":"boise@advantageelc.com",
                "email_link":"boise@advantageelc.com"
              },
              {
                "name":"Meridian",
                "map":"https://goo.gl/maps/rUJ5bYqg4C5RLp786",
                "phone":"(208) 391-2200",
                "phone_link":"+12083912200",
                "email":"meridian@advantageelc.com",
                "email_link":"meridian@advantageelc.com"
              }
          ]
}
    }
  },
  watch: {
    headerData: {
      handler(val, oldVal) {
        console.log(val);
        var headerData=val
        var html=null
        this.$emit('setHeader',makeHeader(headerData,html))

            function makeHeader(headerData,html){
            html = `<div kvsb-data="sb-header" class="top-left sb-header">`;
            headerData.locations.forEach(location => {
            html += `<ul class="info-list clearfix">
            <li><a href="${location.map}" target="_blank">${location.name}:</a></li>
            <li><a href="tel:${location.phone_link}"><span class="fa fa-phone-square"></span> ${location.phone}</a></li>
            <li><a href="mailto:${location.email_link}"><span class="fa fa-envelope"></span>${location.email}</a></li>
            </ul>`;
            });
            html +=`</div>`;
            return html
            }
        // if(this.menu_temp && this.menuData){
        //     var menuData=val
        //     var html=null
        //     eval(this.menu_temp);
        //     // console.log(html)
        //     this.createMenu(html)
        //     this.$emit('setMenuData',val)

        //   }
          

        //  this.$emit("setMenu", html);
      },
      deep: true,
    },
    isSidebarActive (val) {

    },
    LinkData:{
      handler(val, oldVal) {
        console.log(val)
        //  this.$emit("setNewLink",val)
      },
      deep: true,
    },
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },
    isFormValid () {
      return !this.errors.any()  
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag },
    DataJSON(){
      if(this.data){
            this.LinkData=JSON.parse(this.data)
      }
      
    }

  },
  methods: {

    initValues () {
 
    },
    submitData () {
      this.$validator.validateAll().then(result => {
        if (result) {
 
           this.$emit("setNewLink",this.LinkData)



        }
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }
}
</style>
